import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import SkeletonMenuLoader from "../../components/SkeletonMenuLoader";
import { getRestaurantMenuUICustomizations } from "../../../../../utilities/restaurantMenuCustomizationsUtil";
import {
    setRestaurantMenuUICustomizations,
    fetchAllRestaurantMenuData,
    setSelectedOrderType,
    getAllData,
    getAvailableMenus,
    getAvailableMenuItems,
    setOrderData,
} from "../../../../../../../redux/resturantWidgetSlice";
import "./Menu.scss";
import LocationFinder from "../../components/OrderPicker/LocationFinder/LocationFinder";
import Modal from "../../components/Modal/Modal";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { useHistory } from "react-router";
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { getHomeBanners, getMessages, getRecommendationItems } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import CollectionStorePicker from "../../components/Drawers/CollectionStorePicker/CollectionStorePicker";
import DeliveryAddressPicker from "../../components/Drawers/DeliveryAddressPicker/DeliveryAddressPicker";
import OrderSelection from "../../components/OrderPicker/OrderSelection/OrderSelection";
import LayoutTemplateV3 from "../../components/layouts/LayoutTemplateV3";
import RightCart from "../../components/Drawers/RightDrawerCart/RightCart";
import { getFloorDetails, updateOrderTypeDetails } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import TableModal from "../../components/layouts/ItemModal/TableModal";
import arrow from "../../assets/arrow-black.svg"
import { setLocalStorageData } from "../../../../../utilities/helper";

const HomeMenuV3 = ({ menu, locationFinder }) => {
    const dispatch = useDispatch();
    const itemRefs = useRef([]);
    const tabRefs = useRef([]);
    const { selectedOrderType } = useSelector((state) => state.resturantData);

    const { menuData: { isLoading, storage: { mainMenus } }, menuData, defualtSelectedLocation, organizationID, orderCartData } = useSelector((state) => state.resturantData);
    const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes.filter(val => val !== "table")
    const [widgetState, setWidgetState] = useState({
        isPopup: null,
        layout: null,
        customizations: null,
        themeAvailable: false,
        isInitialLoading: true,
    });
    const [addDeliveryLoc, setAddDeliveryLoc] = useState(locationFinder ?? false);
    const [deliverySuccess, setDeliverySuccess] = useState(false);
    const [deliveryFailed, setDeliveryFailed] = useState(false);
    const [collectionStore, setCollectionStore] = useState(false);
    const [deliveryPicker, setDeliveryPicker] = useState(false);
    const [data, setData] = useState(null)
    const [checkoutFailed, setCheckoutFailed] = useState("");
    const [isStoreClosed, setIsStoreClosed] = useState(false);
    const [isStoreOrderBlocked, setIsStoreOrderBlocked] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isScheduleError, setIsScheduleError] = useState(false);
    const [isScheduleTimeError, setIsScheduleTimeError] = useState(false);
    const [selectedItem, setSelectedItem] = useState(sessionStorage.getItem(`scroll`) ? sessionStorage.getItem(`scroll`) : "");
    const heightTop = window.innerWidth < 600 ? 240 : 120
    const [selectedFloor, setSelectedFloor] = useState(null)
    const [selectedTable, setSelectedTable] = useState(null)
    const [showChangeTable, setShowChangeTable] = useState(false)
    const [floorData, setFloorData] = useState([])
    const [tables, setTables] = useState([])
    const [suggestedIetms, setSuggestedItems] = useState([])
    const [messages, setMessages] = useState([])


    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [schedModal, setSchedModal] = useState(
        localStorage.getItem("failedDeliveryOpt") && localStorage.getItem("failedDeliveryOpt") === "true" && localStorage.getItem("schedule_order") ? true : false
    );
    const restaurantDataState = useSelector((state) => state.resturantData);
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    useEffect(() => {
        getAllData().then((result) => {
            setData(result);
        });
    }, []);
    const [itemsData, setItemsData] = useState(data)
    const [location, setLocation] = useState({
        city: '',
        state: '',
        country: '',
        postal: "",
        lat: '',
        lng: '',
        countryCode: '',
        addressLine1: "",
    });
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        localStorage.setItem("selected_cat", "home")
    }, []);
    const initializeMenuCustomizations = useCallback(async () => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
        const data = {
            "device": window.screen.width < 600 ? "mobile" : "desktop",
            "location": "home",
            "userSegments": [
                "premium",
                "returning"
            ],
            "country": "US",
            "category": "summer",
            "limit": 5,
            "organizationId": organizationID,
            "cloudlocationId": defualtSelectedLocation.CloudLocationID
        }
        await getHomeBanners(data).then((res) => {
            if (res) {
                setBanners(res)
            }
        })
        await getMessages(organizationID, defualtSelectedLocation.CloudLocationID)
            .then((res) => {
                if (res) {
                    let resData = res?.filter((message) => message.displayPage === "menu")
                    setMessages(resData)
                } else {
                    setMessages([])
                }
            })
        if (menu) {
            const menuDataValue = JSON.parse(menu);
            const menuCustomizationValues = getRestaurantMenuUICustomizations(menuDataValue);
            dispatch(setRestaurantMenuUICustomizations({ uiCustomizations: menuCustomizationValues }));
            setWidgetState((prevState) => ({
                ...prevState,
                customizations: menuDataValue,
                isPopup: menuDataValue?.selectedCard === 'popup',
                layout: menuDataValue?.selectedLayout,
                themeAvailable: menuDataValue?.selctedTheme !== "removeTheme",
            }));

        }
    }, [menu, dispatch]);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: defualtSelectedLocation.CloudLocationID,
            OrganizationID: organizationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);

    useEffect(() => {
        initializeMenuCustomizations();

    }, [initializeMenuCustomizations]);

    useEffect(() => {
        fetchMenuData();
        localStorage.setItem("ecom_del_view", "true")
    }, [fetchMenuData]);

    useEffect(() => {
        if (!isLoading) {
            const menuDataObject = menuData.storage
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };

            setItemsData(updatedData);
            setWidgetState((prevState) => ({ ...prevState, isInitialLoading: false }));
        }

    }, [isLoading, data]);
    let categories = itemsData && itemsData?.Categories
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items;
    }
    useEffect(() => {
        if (!widgetState.isInitialLoading) {
            if (data && selectedItem === "") {
                if (selectedItem === "") {
                    setSelectedItem(categories[0]?.MenuCategoryID
                    );
                    sessionStorage.setItem(`scroll`, categories[0]?.MenuCategoryID
                    );
                    window.scrollTo({ top: 0, behavior: "smooth" });
                } else {

                    let scroll = sessionStorage.getItem(`scroll`)
                    setSelectedItem(scroll);
                    const selectedItemPosition = itemRefs.current[scroll].getBoundingClientRect().top + window.scrollY - 200;
                    window.scrollTo(0, parseInt(selectedItemPosition, 10));
                }
            } else {
                if (itemRefs) {
                    let scroll = sessionStorage.getItem(`scroll`)
                    if (scroll && scroll !== undefined) {

                        setSelectedItem(scroll);
                        const selectedItemPosition = itemRefs?.current[scroll] !== undefined && (itemRefs?.current[scroll]?.getBoundingClientRect()?.top + window.scrollY) - 200;
                        window.scrollTo(0, parseInt(selectedItemPosition, 10));
                    }
                }
            }

        }
    }, [widgetState])
    useEffect(() => {
        const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
        if (defaultDetails && defaultDetails.selectedOrderType === "table") {
            getFloorDetails().then((response) => {
                if (response) {
                    let floorsData = response.filter((flr) => flr.Tables.length > 0)

                    setFloorData(floorsData)
                    let value = floorsData.map((floor) =>
                        floor.Tables.map((table) => {
                            if (table.LocalID === defaultDetails.tableLocalId) {

                                let floorDataValue = {
                                    Id: floor.ID,
                                    Name: floor.ItemName.Translations.en,
                                    LocalReference: { Id: floor.LocalID }
                                }
                                let data = {
                                    TableID: table.ID,
                                    TableName: table.TableName,
                                    LocalReference: { Id: table.LocalID },
                                    Floor: floorDataValue,
                                    Covers: table.Covers
                                }
                                setSelectedFloor(floorDataValue)
                                setSelectedTable(data)
                                setTables(floor.Tables)
                                localStorage.setItem("selected_table", JSON.stringify(data))
                                return data;
                            }
                            return null;
                        })
                    )
                        .flat()
                        .filter(Boolean)[0];
                }
            })
        }
    }, [])
    const setFloorDataInitial = () => {
        let selTable = localStorage.getItem("selected_table");
        const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
        if (!selTable) {
            getFloorDetails().then(async (response) => {
                if (response && response.length > 0) {
                    let floorsData = response.filter((flr) => flr.Tables.length > 0)
                    setFloorData(floorsData)
                    const firstFloor = floorsData[0];
                    const firstTable = firstFloor.Tables?.[0];
                    setTables(firstFloor.Tables)

                    if (firstFloor && firstTable) {
                        const floorDataValue = {
                            Id: firstFloor.ID,
                            Name: firstFloor.ItemName?.Translations?.en,
                            LocalReference: { Id: firstFloor.LocalID },
                        };

                        const data = {
                            TableID: firstTable.ID,
                            TableName: firstTable.TableName,
                            LocalReference: { Id: firstTable.LocalID },
                            Floor: floorDataValue,
                            Covers: firstTable.Covers,
                        };

                        setSelectedFloor(floorDataValue);
                        setSelectedTable(data);
                        let storageData = {
                            ...defaultDetails,
                            tableLocalId: firstTable.LocalID

                        }
                        await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, storageData);
                        localStorage.setItem("selected_table", JSON.stringify(data));
                        setShowChangeTable(true)

                    }
                }
            });
        }
    };

    useEffect(() => {
        const handleScroll = () => {

            const scrollPosition = window.scrollY + heightTop;
            let activeId = null;

            Object.entries(itemRefs.current).forEach(([id, item]) => {
                if (item) {
                    const { top, bottom } = item.getBoundingClientRect();
                    const itemTop = top + window.scrollY - heightTop;
                    const itemBottom = bottom + window.scrollY - heightTop;

                    if (itemTop <= scrollPosition && itemBottom >= scrollPosition) {
                        activeId = id;
                    }
                }
            });
            if (activeId) {
                setSelectedItem(activeId);
                sessionStorage.setItem(`scroll`, activeId);
                tabRefs.current[activeId]?.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const handleSelect = (id) => {
        if (!itemRefs.current[id]) return;

        setSelectedItem(id);
        sessionStorage.setItem(`scroll`, id);

        const selectedItemPosition = itemRefs.current[id].getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: selectedItemPosition, behavior: "smooth" });

        setTimeout(() => {
            tabRefs.current[id]?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }, 200);
    };
    useEffect(() => {
        let orderTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
        if (orderTypes) {
            if (orderTypes?.selectedOrderType !== "" && orderTypes?.selectedOrderType !== "table") {
                if (availableTypes && availableTypes.length === 1) {
                    if (availableTypes[0] === "collection") {
                        dispatch(setSelectedOrderType(availableTypes[0]))
                    } else {
                        if (selectedOrderType === "") {
                            setAddDeliveryLoc(true)
                        }
                    }
                }
            } else {
                if (selectedOrderType === "" && availableTypes.length === 0) {
                    dispatch(setSelectedOrderType(orderTypes.defaultOrderType))
                    setFloorDataInitial()
                }
            }
        }

    }, [availableTypes])
    const isStoreOpen = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.openingHours?.find(day => day.Day === currentDay);
        if (!today || today.Closed) return false;

        for (let hours of today.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }
    const getCartTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.Formatted ?? "£ 0.00"

    }
    const containerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);

    useEffect(() => {
        const checkScroll = () => {
            const el = containerRef.current;
            if (!el) return;

            setShowLeftArrow(el.scrollLeft > 10);
            setShowRightArrow(el.scrollWidth > el.clientWidth + el.scrollLeft + 10);
        };

        const el = containerRef.current;
        if (el) el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        checkScroll();

        return () => {
            if (el) el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [categories]);

    useEffect(() => {
        const fetchSuggestions = async () => {
            if (restaurantDataState?.orderCartData?.Items?.length > 0) {
                const suggested = await getSuggestItems();
                if (suggested.length > 0) {
                    setSuggestedItems(suggested);
                } else {
                    setSuggestedItems([])
                }
            }
        };

        fetchSuggestions();
    }, [orderCartData]);


    const getSuggestItems = async () => {
        if (restaurantDataState?.orderCartData?.Items?.length > 0) {
            let reqData = {
                item_ids: restaurantDataState.orderCartData.Items.map(item => item.CartItemID),
                store_id: defualtSelectedLocation.CloudLocationID,
                limit: 5,
            };

            try {
                const res = await getRecommendationItems(reqData);
                if (res) {
                    if (res?.recommendations?.length > 0) {
                        const idsToRemove = restaurantDataState?.orderCartData?.Items.map(item => item.CartItemID);
                        const filteredArr1 = res.recommendations.filter(item => !idsToRemove.includes(item.menu_item_id));
                        const orderedItems = filteredArr1
                            .sort((a, b) => a.rank - b.rank)
                            .map(ranked =>
                                itemsData?.Items?.find(item => item.MenuItemID === ranked.menu_item_id)
                            )
                            .filter(Boolean);

                        return orderedItems;
                    } else {
                        return []
                    }
                } else {
                    return []
                }
            } catch (err) {
                console.error("Error fetching suggested items:", err);
            }
        }

        return [];
    };
    console.log(selectedOrderType, "selectedOrderType")
    return (

        <div>
            <LocationFinder visibility={addDeliveryLoc}
                setAddDeliveryLoc={setAddDeliveryLoc}
                onPopupClose={() => {
                    setAddDeliveryLoc(false)
                }}
                setDeliverySuccess={setDeliverySuccess}
                setDeliveryFailed={setDeliveryFailed}
                location={location}
            />
            <CollectionStorePicker
                isOpen={collectionStore}
                setIsOpen={setCollectionStore}
            />
            <DeliveryAddressPicker
                isOpen={deliveryPicker}
                setIsOpen={setDeliveryPicker}
                setLocation={setLocation} />

            <Modal visibility={deliverySuccess} type="success" headerText="Great news! We deliver to your location" subText="Enjoy fresh and fast delivery straight to your doorstep. Place your order now!" onPopupClose={() => {
                setDeliverySuccess(false)
            }} />
            <Modal visibility={deliveryFailed} type="failed" headerText="Uh-oh! Looks like we can’t reach you" subText={`Sorry, we don’t currently deliver to your area. Stay tuned for updates!`} onPopupClose={() => {
                setDeliveryFailed(false)
            }} />
            <Modal visibility={checkoutFailed !== ""} type="failed" headerText="Sorry!" subText={checkoutFailed} onPopupClose={() => {
                setCheckoutFailed("")
            }} />
            <Modal visibility={isStoreOrderBlocked} type="failed" headerText={selectedOrderType + " Unavailable"} subText={`Store is not accepting ${selectedOrderType} orders at the moment. Would you like to switch your order type to ${selectedOrderType === "collection" ? "delivery" : "collection"} instead?`}
                onPopupClose={() => {
                    let type = selectedOrderType === "collection" ? "delivery" : "collection"
                    if (type === "collection") {
                        dispatch(setSelectedOrderType("collection"))
                        updateOrderType("TAKE_AWAY")
                    } else {
                        setAddDeliveryLoc(true)
                    }
                    setIsStoreOrderBlocked(false)
                }}
            />
            <Modal visibility={isScheduleError} type="failed" headerText="Store is Currently Closed" subText="Please schedule your order for a later time to proceed to checkout."
                onPopupClose={() => {
                    setIsScheduleError(false)
                    setIsStoreClosed(true)
                }}
            />
            <Modal visibility={isScheduleTimeError} type="failed" headerText="Scheduled Time Has Passed" subText=" Please update the scheduled time to proceed with your order."
                onPopupClose={() => {
                    setIsScheduleTimeError(false)
                    setIsStoreClosed(true)
                }}
            />
            <Modal visibility={schedModal} type="failed" headerText=" Scheduled Time May Be Affected!" subText={`Sorry, Please review your scheduled order time. It may no longer be valid with the new ordering type. Adjust the schedule if necessary.`} onPopupClose={() => {
                localStorage.removeItem("failedDeliveryOpt")
                setSchedModal(false)
                localStorage.removeItem("schedule_order")
                setIsStoreClosed(true)
            }} />
            <Modal visibility={isStoreClosed} type="closed" headerText=" We’ll Be Back Soon!" subText={
                "We're sorry, but the store is currently closed. Please check our hours and visit us later!"
            } onPopupClose={() => {
                setIsStoreClosed(false)
            }}
                btnText={"VIEW STORE"} />
            {/* <PopupWrapper isPopup={widgetState.isPopup}
            > */}
            {selectedOrderType === "" ? (

                <OrderSelection setAddDeliveryLoc={setAddDeliveryLoc}
                    setCollectionStore={setCollectionStore} />


            ) : widgetState.isInitialLoading ? (
                <SkeletonMenuLoader />
            ) : (

                <div className="HomeMenustyles">
                    <ImageCarousel content={banners} />
                    <div className="HomeMenustyles-inner">
                        <div className="HomeMenustyles-inner-left">
                            {messages.map((message, key) => {
                                return (
                                    <div className={`current-status-cont-${message?.type}`} key={key}>
                                        <div className="header-cont-title ">{message?.title}</div>
                                        <div className={`current-status-cont-${message?.type}-sub`}>
                                            {message?.content}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {selectedOrderType === "table" && selectedTable && <div
                            className="HomeMenustyles-inner-right">
                            <img alt="" src='https://media-cdn.tripadvisor.com/media/photo-m/1280/26/ac/0f/89/salle-restaurant-nuit.jpg' className="HomeMenustyles-inner-right-img" />
                            <div className="table-selection">
                                <div className="table-selection-name">Table : {selectedTable?.TableName} ({selectedFloor?.Name})</div>
                                <div className="table-selection-change"
                                    onClick={() => {
                                        setShowChangeTable(true)
                                    }}>Change</div>
                            </div>
                        </div>}
                    </div>
                    <div className="HomeMenustyles-inner">
                        <div className="HomeMenustyles-inner-menu">


                            {categories?.length > 0 && <div className="HomeMenustyles-inner-menu-cont"
                                style={{ top: localStorage.getItem("schedule_order") && window.screen.width < 1200 ? "150px" : (selectedOrderType === "table" && window.screen.width < 1200) ? "52px" : (selectedOrderType === "delivery" && window.screen.width < 1200) ? "172px" : "" }}>
                                {showLeftArrow &&
                                    <div
                                        className="arrow-emnu-left"
                                        onClick={() =>
                                            (containerRef.current.scrollLeft -= 150)
                                        }
                                    >
                                        <img alt="" src={arrow} />
                                    </div>}

                                <div className="HomeMenustyles-inner-menu-cont-items" ref={containerRef}>
                                    {categories.map((category) => {
                                        return (
                                            <div
                                                className={selectedItem === category?.MenuCategoryID ? "HomeMenustyles-inner-menu-cont-items-item-selected" : "HomeMenustyles-inner-menu-cont-items-item"}
                                                ref={(el) => (tabRefs.current[category?.MenuCategoryID] = el)}
                                                onClick={() => {
                                                    handleSelect(category?.MenuCategoryID)
                                                }}
                                            >{category?.Title?.en}</div>
                                        )
                                    })}</div>
                                {showRightArrow && <div
                                    className="arrow-emnu-right"
                                    onClick={() =>
                                        (containerRef.current.scrollLeft += 150)
                                    }
                                >
                                    <img alt="" src={arrow} />

                                </div>}
                            </div>}

                            {categories.map((category) => {
                                return (
                                    <LayoutTemplateV3 layout={"layout2"} items={
                                        getCatgoryItems(category.MenuEntities)
                                    } showHeader
                                        headerText={category?.Title?.en}
                                        hideFav={true}
                                        limited={false}
                                        itemRefs={itemRefs}
                                        category={category} />
                                )
                            })}
                        </div>
                        <div className="HomeMenustyles-inner-cart">
                            <RightCart
                                isStoreOpen={isStoreOpen}
                                setCheckoutFailed={setCheckoutFailed}
                                setIsStoreClosed={setIsStoreClosed}
                                setIsStoreOrderBlocked={setIsStoreOrderBlocked}
                                setIsScheduleError={setIsScheduleError}
                                setIsScheduleTimeError={setIsScheduleTimeError}
                                isMobile={false}
                                isOpen={true}
                                setIsOpen={() => { }}
                                suggestedItems={suggestedIetms}


                            />
                        </div>
                    </div>
                    {isOpen && <div className="HomeMenustyles-cart">
                        <RightCart
                            isStoreOpen={isStoreOpen}
                            setCheckoutFailed={setCheckoutFailed}
                            setIsStoreClosed={setIsStoreClosed}
                            setIsStoreOrderBlocked={setIsStoreOrderBlocked}
                            setIsScheduleError={setIsScheduleError}
                            setIsScheduleTimeError={setIsScheduleTimeError}
                            isMobile={true}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            suggestedItems={suggestedIetms}

                        />
                    </div>}
                    {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 && !isOpen &&
                        < div className="mobilecart-fix">
                            <div className="mobilecart-fix-inner"
                                onClick={() => {
                                    setIsOpen(true)
                                }}>
                                <div className="mobilecart-fix-inner-item1">{restaurantDataState.orderCartData.Items.length}</div>
                                <div className="mobilecart-fix-inner-item2">Next: View Order</div>
                                <div className="mobilecart-fix-inner-item3">{getCartTotal()}</div>
                            </div>
                        </div>}
                </div>
            )
            }
            {showChangeTable && <TableModal
                visibility={showChangeTable}
                onClose={() => {
                    setShowChangeTable(false)
                }}
                setSelectedFloor={setSelectedFloor}
                selectedTable={selectedTable}
                setSelectedTable={setSelectedTable}
                selectedFloor={selectedFloor}
                floors={floorData}
                tables={tables}
                setTables={setTables} />}
        </div >
    );
};

export default HomeMenuV3;
